import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0828 = React.lazy(() => import('./symbols/0828_basket_ball_sports'));
const Symbol0829 = React.lazy(() => import('./symbols/0829_golf_course_sports'));
const Symbol0830 = React.lazy(() => import('./symbols/0830_table_tennis_ping_pong_sports'));
const Symbol0831 = React.lazy(() => import('./symbols/0831_basket_ball_sports'));
const Symbol0832 = React.lazy(() => import('./symbols/0832_football_stadium_green_court_sports'));
const Symbol0833 = React.lazy(() => import('./symbols/0833_referee_whistle'));
const Symbol0834 = React.lazy(() => import('./symbols/0834_ragby_amercian_football_sports'));
const Symbol0835 = React.lazy(() => import('./symbols/0835_football_soccer_sports'));
const Symbol0836 = React.lazy(() => import('./symbols/0836_baseball_sports'));
const Symbol0837 = React.lazy(() => import('./symbols/0837_baseball_tennis_ball_sports'));
const Symbol0838 = React.lazy(() => import('./symbols/0838_watch_heart_fitness_running_tracker'));
const Symbol0839 = React.lazy(
  () => import('./symbols/0839_apple_watch_heart_fitness_running_tracker')
);
const Symbol0840 = React.lazy(
  () => import('./symbols/0840_apple_watch_heart_fitness_running_tracker')
);
const Symbol0841 = React.lazy(() => import('./symbols/0841_apple_watch_music_song_fitness'));
const Symbol0842 = React.lazy(() => import('./symbols/0842_fitness_running'));
const Symbol0843 = React.lazy(() => import('./symbols/0843_fitness_cycling'));
const Symbol0844 = React.lazy(() => import('./symbols/0844_stopwatch_training_time'));
const Symbol0845 = React.lazy(
  () => import('./symbols/0845_fitness_weight_gym_lifting_bodybuilding_training')
);
const Symbol0846 = React.lazy(
  () => import('./symbols/0846_fitness_cycle_hometrainer_calories_training')
);
const Symbol0847 = React.lazy(() => import('./symbols/0847_fitness_running_calories_training'));
const Symbol0848 = React.lazy(() => import('./symbols/0848_shoes_gear_fitness_running'));
const Symbol0849 = React.lazy(() => import('./symbols/0849_water_training_hydration'));
const Symbol0850 = React.lazy(() => import('./symbols/0850_swimming'));
const Symbol0851 = React.lazy(() => import('./symbols/0851_hydro_pool'));

export interface IProps {}

const Sports: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0828_basket_ball_sports" symbol={<Symbol0828 />} />
      <LazySymbol id="0829_golf_course_sports" symbol={<Symbol0829 />} />
      <LazySymbol id="0830_table_tennis_ping_pong_sports" symbol={<Symbol0830 />} />
      <LazySymbol id="0831_basket_ball_sports" symbol={<Symbol0831 />} />
      <LazySymbol id="0832_football_stadium_green_court_sports" symbol={<Symbol0832 />} />
      <LazySymbol id="0833_referee_whistle" symbol={<Symbol0833 />} />
      <LazySymbol id="0834_ragby_amercian_football_sports" symbol={<Symbol0834 />} />
      <LazySymbol id="0835_football_soccer_sports" symbol={<Symbol0835 />} />
      <LazySymbol id="0836_baseball_sports" symbol={<Symbol0836 />} />
      <LazySymbol id="0837_baseball_tennis_ball_sports" symbol={<Symbol0837 />} />
      <LazySymbol id="0838_watch_heart_fitness_running_tracker" symbol={<Symbol0838 />} />
      <LazySymbol id="0839_apple_watch_heart_fitness_running_tracker" symbol={<Symbol0839 />} />
      <LazySymbol id="0840_apple_watch_heart_fitness_running_tracker" symbol={<Symbol0840 />} />
      <LazySymbol id="0841_apple_watch_music_song_fitness" symbol={<Symbol0841 />} />
      <LazySymbol id="0842_fitness_running" symbol={<Symbol0842 />} />
      <LazySymbol id="0843_fitness_cycling" symbol={<Symbol0843 />} />
      <LazySymbol id="0844_stopwatch_training_time" symbol={<Symbol0844 />} />
      <LazySymbol
        id="0845_fitness_weight_gym_lifting_bodybuilding_training"
        symbol={<Symbol0845 />}
      />
      <LazySymbol id="0846_fitness_cycle_hometrainer_calories_training" symbol={<Symbol0846 />} />
      <LazySymbol id="0847_fitness_running_calories_training" symbol={<Symbol0847 />} />
      <LazySymbol id="0848_shoes_gear_fitness_running" symbol={<Symbol0848 />} />
      <LazySymbol id="0849_water_training_hydration" symbol={<Symbol0849 />} />
      <LazySymbol id="0850_swimming" symbol={<Symbol0850 />} />
      <LazySymbol id="0851_hydro_pool" symbol={<Symbol0851 />} />
    </>
  );
});

Sports.displayName = 'Sports';

export default Sports;
